// extracted by mini-css-extract-plugin
export var navbarSubLink = "J_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "J_t7 d_f0 d_dB";
export var subPageLink = "J_gf d_gf";
export var burger = "J_vR";
export var sublinkSize = "J_vS";
export var linkSize = "J_vT";
export var Link = "J_tC y_tC y_sX y_tg";